// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
// 
// Copyright (c) 2015-present Evan You
// 
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// 
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
// 
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import config from '../../../../share/config';
import session from '../../../../share/session';
import util from "../../../../share/util/utils";

/** メッセージ内の置き換え文字列定義 */
const DID = '$DID$';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  CURRENT_OIL_TEMPERATURE: 'currentOilTemperature',
  FAILED: 'failed',
  SUCCESS: 'success',
  VEHICLE_CONDITION: 'vehicleCondition',
  OIL_CONDITION: 'oilCondition',
  EXECUTION_CONDITION: 'executionCondition',
  LOWER_OIL_TEMPERATURE: 'lowerOilTemperature',
  HIGHER_OIL_TEMPERATURE: 'higherOilTemperature',
  START_ENGINE: 'startEngine',
  PRESS_BRAKE: 'pressBrake',
  SELECT_RANGE: 'selectRange',
  MODE_MOVE: 'modeMove',
};

export default {
  name: 'requirement026',
  data() {
    return {
      isLoading: false,
      phase: PHASE.START,
      systemId: '',
      displayInfo: '',
      replaceMessage: '',
      currentValue: '',
      lowerLimit: '',
      upperLimit: '',
      unit: '',
      state: '',
      numWaitTime: 0,
      keepStopResponse: false,
      buttonModeFlg: 0,
      isDisabled: false,
      isRetry: false,
      // ダイアログフラグ
      modal_requirement_026: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.VEHICLE_CONDITION:
        case PHASE.OIL_CONDITION:
        case PHASE.EXECUTION_CONDITION:
        case PHASE.HIGHER_OIL_TEMPERATURE:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.LOWER_OIL_TEMPERATURE:
        case PHASE.CURRENT_OIL_TEMPERATURE:
        case PHASE.START_ENGINE:
        case PHASE.PRESS_BRAKE:
        case PHASE.MODE_MOVE:
        default:
          return 'secondary';
      }
    },
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      this.modal_requirement_026 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_026 = false;
    },

    /**
     * Exit処理
     * @param {*} numError 0:エラー遷移あり, 1:エラー遷移なし
     * @returns 
     */
    async exit(numError) {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (numError === 0) {
          // エラー遷移あり
          if (response) {
            // 正常コールバック
            switch (response.data.status) {
              case config.STATUS_WSP_COMPLETED:
                // 正常終了：機能終了
                this.closeWizard();
                break;
              case config.STATUS_WSP_FAILED:
              default:
                // 異常終了：汎用エラー
                this.showUnexpectedError();
                return;
            }
          }
        } else {
          // エラー遷移なし：機能終了
          this.closeWizard();
          return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result handler.validate で返ってきたバリデーション結果
    */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** データ読み出し処理 */
    async execute() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read_with_session_transition-init',
            is_retry : this.isRetry
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // データ読み出し処理再実行フラグ
        this.isRetry = true;

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  this.currentValue = response.data.user_data.atf_temperature.current_value;
                  this.upperLimit = response.data.user_data.atf_temperature.upper_limit;
                  this.lowerLimit = response.data.user_data.atf_temperature.lower_limit;
                  this.unit = this.$t(`didUnit.${response.data.user_data.atf_temperature.unit}`);
                  // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                  /* eslint-disable max-depth */
                  if (this.currentValue < this.lowerLimit) {
                    this.replaceMessage = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_2`).replace(DID, this.currentValue);
                    this.replaceMessage = this.replaceMessage.replace(DID, this.lowerLimit);
                    this.displayInfo = this.replaceMessage;
                    // 現在油温表示画面へ遷移
                    this.phase = PHASE.CURRENT_OIL_TEMPERATURE;
                  } else {
                    // 油温条件不成立表示画面へ遷移
                    this.replaceMessage = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_14`).replace(DID, this.lowerLimit);
                    this.replaceMessage = this.replaceMessage.replace(DID, this.currentValue);
                    this.displayInfo = this.replaceMessage;
                    this.phase = PHASE.OIL_CONDITION;
                  }
                  break;
                case 'ng':
                  // 車両状態不成立表示画面へ遷移
                  this.phase = PHASE.VEHICLE_CONDITION;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** ローディング画面へ遷移 */
    async loadingProcess() {
      this.phase = PHASE.START;
      await this.execute();
    },

    /** エンジンON指示画面へ遷移 */
    async startEnginProcess() {
      this.phase = PHASE.START_ENGINE;
      await this.engineStart();
    },

    //** エンジンON指示 */
    async engineStart() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-engine_start'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：ブレーキ踏み込み指示画面へ遷移
              this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_4`);
              this.phase = PHASE.PRESS_BRAKE;
              await this.brakeStepOn();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    //** ブレーキ踏み込み指示 */
    async brakeStepOn() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-brake'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // ウェイト時間取得(ブレーキ踏み込み維持指示画面で使用)
              this.numWaitTime = response.data.user_data.wait_time;
              // 正常終了：ブレーキ踏み込み維持指示画面へ遷移
              this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_5`);
              this.phase = PHASE.PRESS_BRAKE;
              await this.pressBrakeMaintain();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** ブレーキ踏み込み維持指示 */
    async pressBrakeMaintain() {
      this.isLoading = true;
      // 指定時間計測
      await util.sleep(this.numWaitTime);
      this.isLoading = false;
      this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_6`);
      // Rレンジセレクト指示画面(1)へ遷移
      this.phase = PHASE.SELECT_RANGE;
      await this.rRangeSelectFirst();
    },

    /** Rレンジセレクト指示(1) */
    async rRangeSelectFirst() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-select_r1'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：Nレンジセレクト指示画面(1)へ遷移
              this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_7`);
              this.phase = PHASE.SELECT_RANGE;
              await this.nRangeSelectFirst();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Nレンジセレクト指示(1) */
    async nRangeSelectFirst() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-select_n1'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：Dレンジセレクト指示画面(1)へ遷移
              this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_8`);
              this.phase = PHASE.SELECT_RANGE;
              await this.dRangeSelectFirst();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Dレンジセレクト指示(1) */
    async dRangeSelectFirst() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-select_d1'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：Mレンジセレクト指示画面(1)へ遷移
              this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_9`);
              this.phase = PHASE.SELECT_RANGE;
              await this.mRangeSelectFirst();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Mレンジセレクト指示(1) */
    async mRangeSelectFirst() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-select_m'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：Dレンジセレクト指示画面(2)へ遷移
              this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_8`);
              this.phase = PHASE.SELECT_RANGE;
              await this.dRangeSelectSecond();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Dレンジセレクト指示(2) */
    async dRangeSelectSecond() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-select_d2'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：Nレンジセレクト指示画面(2)へ遷移
              this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_7`);
              this.phase = PHASE.SELECT_RANGE;
              await this.nRangeSelectSecond();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Nレンジセレクト指示(2) */
    async nRangeSelectSecond() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-select_n2'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：Rレンジセレクト指示画面(2)へ遷移
              this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_6`);
              this.phase = PHASE.SELECT_RANGE;
              await this.rRangeSelectSecond();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Rレンジセレクト指示(2) */
    async rRangeSelectSecond() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-select_r2'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：Pレンジセレクト指示画面へ遷移
              this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_10`);
              this.phase = PHASE.SELECT_RANGE;
              await this.pRangeSelect();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Pレンジセレクト指示 */
    async pRangeSelect() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-select_p'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：開始油温判定処理を実行
              await this.judgeOilTemperature();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 開始油温判定処理 */
    async judgeOilTemperature() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-oil_judge'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              this.currentValue = response.data.user_data.atf_temperature.current_value;
              this.unit = this.$t(`didUnit.${response.data.user_data.atf_temperature.unit}`);
              if (this.currentValue < this.lowerLimit) {
                // 油温調整モード開始処理を実行
                await this.startOilTemperatureAdjustmentMode();
              } else {
                // 油温条件不成立画面へ遷移
                this.replaceMessage = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_14`).replace(DID, this.lowerLimit);
                this.replaceMessage = this.replaceMessage.replace(DID, this.currentValue);
                this.displayInfo = this.replaceMessage;
                this.phase = PHASE.OIL_CONDITION;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 油温調整モード開始処理 */
    async startOilTemperatureAdjustmentMode() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'iocp_output_change'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // モード移行確認画面へ遷移
                  this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_11`);
                  this.phase = PHASE.MODE_MOVE;
                  await this.modeTransitionConfirmation();
                  break;
                case 'ng':
                  // 実行条件不成立画面へ遷移
                  this.phase = PHASE.EXECUTION_CONDITION;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** モード移行確認／IOCP出力継続 */
    async modeTransitionConfirmation() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'iocp_output_keep'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              switch (response.data.user_data.result) {
                case 'ok':
                  // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                  /* eslint-disable max-depth */
                  if (this.buttonModeFlg === 0) {
                    // OKボタン押下：油温測定処理
                    await this.measurementOilTemperature();
                  } else {
                    // キャンセルボタン押下：IOCP復帰処理
                    await this.iocpOutputReturn();
                  }
                  break;
                case 'ng':
                  // 実行条件不成立画面へ遷移
                  this.phase = PHASE.EXECUTION_CONDITION;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * IOCP出力継続処理停止の呼び出し
     * @param {*} buttonMode 0: モード移行確認画面のOKボタン押下, 1:キャンセルボタン押下
     * @returns 
     */
    async iocpOutputKeepStopProcess(buttonMode) {

      this.buttonModeFlg = buttonMode;

      // Responseが返ってくるまでIOCP出力継続処理停止処理を繰り返す
      const repeatKeepStop = async () => {
        if (this.keepStopResponse) {
          // 処理を終了
          return;
        }
        this.iocpOutputKeepStop(buttonMode);
        setTimeout(repeatKeepStop, 15000); // 15秒後に再度実行
      };

      repeatKeepStop(); // 初回の呼び出し
    },

    /** IOCP出力継続処理停止 */
    async iocpOutputKeepStop() {
      try {
        // awaitで呼び出していないため、処理途中でスピナーが止まることからスピナーを設定しない
        // (modeTransitionConfirmationで設定しているため、スピナーは表示／非表示される)
        
        // OK,キャンセルボタン非活性化
        this.isDisabled = true;

        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'iocp_output_keep-stop'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // Responseは必ずCompletedが返される
        if (response) {
          // 正常終了：IOCP出力継続処理停止を終える
          this.keepStopResponse = true;
        }
      } finally {
        // 何もしない
      }
    },

    /** 油温測定処理 */
    async measurementOilTemperature() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-measure_oil'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              this.currentValue = response.data.user_data.atf_temperature.current_value;
              this.unit = this.$t(`didUnit.${response.data.user_data.atf_temperature.unit}`);
              if (this.currentValue < this.lowerLimit) {
                // 作業可能油温割れ表示画面へ遷移
                this.replaceMessage = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_12`).replace(DID, this.currentValue);
                this.replaceMessage = this.replaceMessage.replace(DID, this.lowerLimit);
                this.replaceMessage = this.replaceMessage.replace(DID, this.upperLimit);
                this.displayInfo = this.replaceMessage;
                this.phase = PHASE.LOWER_OIL_TEMPERATURE;
                // VUE_APP_RETRY_INTERVALの時間分sleep
                await util.sleep(process.env.VUE_APP_RETRY_INTERVAL);
                await this.measurementOilTemperature();
              } else if (this.currentValue > this.upperLimit) {
                // 作業可能油温超過表示画面へ遷移
                this.phase = PHASE.HIGHER_OIL_TEMPERATURE;
              } else {
                // 停止画面へ遷移
                this.replaceMessage = this.$t(`${this.i18nWsKey}.REQ_WS_26_TXT_13`).replace(DID, this.currentValue);
                this.replaceMessage = this.replaceMessage.replace(DID, this.lowerLimit);
                this.replaceMessage = this.replaceMessage.replace(DID, this.upperLimit);
                this.displayInfo = this.replaceMessage;
                this.phase = PHASE.SUCCESS;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** IOCP復帰処理 */
    async iocpOutputReturn() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'iocp_output_return'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：終了処理を実行
              await this.exit(0);
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.FAILED;
    },
  },

  async mounted() {
    this.init();
    // データ読み出し
    this.execute();
  },
};